import { tokenStorage } from '../../core/auth/tokenStorage';

/**
 * Legacy `JwtManager`, adapted to the Architecture 5.0 Platform session.
 *
 * PoseidonFrontend owned its own access token: it stored one in an `encrypt-storage`
 * localStorage entry at login and every request read it back through this class. The
 * Platform web app never signs anyone in itself — it holds a Platform token pair (access
 * token in memory, rotating refresh token in sessionStorage) — so this class is the single
 * adaptation the port needs at the auth boundary.
 *
 * The legacy surface is preserved exactly (`accessToken`, `setAccessToken`,
 * `clearToken`) so every copied component compiles and behaves unchanged.
 */
class JwtManager {
  static get accessToken(): string | null {
    return tokenStorage.getAccessToken();
  }

  /**
   * Kept for source compatibility. Token issuance belongs to the Platform, so a copied
   * component that tries to *set* a token cannot succeed; clearing still works, because
   * that is what the legacy sign-out path relies on.
   */
  static setAccessToken(token: string | null): void {
    if (!token) {
      tokenStorage.clear();
    }
  }

  static clearToken(): void {
    tokenStorage.clear();
  }
}

export default JwtManager;

